import MediaProduction from "../../../classes/mediaProduction";
import FastEvent from "../../../shared/classes/fastEvent";
import { IPlayerState } from "../../types/interfaces/states";
import { RootState } from "../store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: IPlayerState = {
  nextEpisode: {
    asset: undefined,
    display: false,
    enabled: false,
    percentage: 0,
  },
  pilot: false,
};

const playerSlice = createSlice({
  name: "player",
  initialState,
  reducers: {
    resetPlayer: (state) => {
      state.nextEpisode = {
        asset: undefined,
        display: false,
        enabled: false,
        percentage: 0,
      };
      state.pilot = false;
    },
    setNextEpisode: (
      state,
      action: PayloadAction<{
        asset?: FastEvent | MediaProduction;
        display?: boolean;
        enabled?: boolean;
        percentage?: number;
      }>
    ) => {
      // Display next episode when it becomes available
      if (!state.nextEpisode.enabled && action.payload.enabled) {
        state.nextEpisode.display = true;
      }
      // Hide when not available
      if (!action.payload.enabled) {
        state.nextEpisode.display = false;
      }
      // Set any attributes passed through parameters
      state.nextEpisode = { ...state.nextEpisode, ...action.payload };
    },
    setPilot: (state, action: PayloadAction<boolean>) => {
      // Display next episode if possible when pilot is enabled
      if (action.payload && state.nextEpisode.enabled) {
        state.nextEpisode.display = true;
      }
      state.pilot = action.payload;
    },
  },
});

const { actions, reducer: playerReducer } = playerSlice;
export const { resetPlayer, setNextEpisode, setPilot } = actions;
export const playerSelector = (state: RootState) => state.player;
export default playerReducer;
